
<script>
import Pagination from "@/components/Pagination";
import ErrorComponent from "@/components/ErrorComponent";
import Alert from "@/components/Alert";
import moment from "moment";

import CustomerDateRangePicker from '@/components/CustomerDateRangePicker'

export default {
  name: "Shift",
  components: {
    Pagination,
    ErrorComponent,
    Alert,
    CustomerDateRangePicker
  },
  data() {
    return {
      date: {
        startDate: "",
        endDate: ""
      },
      currentPage: 1,
      totalPage: 0,
      itemsPerPage: 10,
      list: [],
      storeList: [],
      currentSorting: "",
      shift: {
        shift_number: null,
        shift_close_by_name: null,
        refunds: null,
        cash_payment: null,
        difference: null,
        pos_name: null,
        created_at: null,
        net_sale: null,
        shift_open_by_name: null,
        card: 0,
        expected_cash_amount: null,
        tax: null,
        paid_out: null,
        cash_refunds: null,
        cash: null,
        id: null,
        actual_cash_amount: null,
        updated_at: null,
        pos_id: null,
        store_name: null,
        gross_sale: null,
        closed_shift: null,
        paid_in: null,
        starting_cash: null,
        total_tendered: null,
        open_shift: null,
        discounts: null
      },
      filterObj: {
        sort_by: "",
        order_by: "ASC",
        store_id: "",
        search: "",
        to_date: "",
        from_date: ""
      }
    };
  },
  methods: {
    retry() {
      this.getList(1);
    },
    pageChange(page) {
      this.getList(page);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(1);
    },
    getList(page, sortBy, orderBy, store_id) {
      this.list = [];
      this.currentPage = page;

      if (sortBy) {
        this.filterObj.sort_by = sortBy;
      }
      if (orderBy) {
        this.filterObj.order_by = orderBy;
      }

      if (this.store_id) {
        this.filterObj.store_id = store_id;
      }

      if (this.search) {
        this.filterObj.search = search;
      }

      this.filterObj.to_date = moment(String(this.date.startDate)).format(
        "Y-M-D"
      );

      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        "Y-M-D"
      );

      this.$api
        .getAPI({
          _action: "/report/shift/" + this.itemsPerPage + "/" + page,
          _body: this.filterObj
        })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.list = res.list;
          }
          if (page == 1) {
            if (res.count != null && res.count > 0) {
              this.$refs.listPagination.setTotalCount(res.count);
            } else {
              this.$refs.listPagination.setTotalCount(0);
            }
          }

          if (!res.list || res.list.length <= 0) {
            this.$refs.errorComonent.setTitle(
              this.$lang.messages.no_shift_found
            );
          } else if (this.$refs.errorComonent.isShowMessage()) {
            this.$refs.errorComonent.setTitle();
          }
        })
        .catch(e => {
          this.$refs.errorComonent.setTitle();
        });
    },
    sorting(e, sortBy) {
      var orderBy = "ASC";

      var className = "sorting_asc";
      var classes = e.target.className;
      if (classes.includes("sorting_asc")) {
        className = "sorting_desc";
      }

      $(".sorting_asc").removeClass("sorting_asc");
      $(".sorting_desc").removeClass("sorting_desc");

      if (className == "sorting_asc") {
        $(e.target)
          .addClass("sorting_asc")
          .removeClass("sorting_desc");
        orderBy = "ASC";
      } else if (className == "sorting_desc") {
        $(e.target)
          .addClass("sorting_desc")
          .removeClass("sorting_asc");
        orderBy = "DESC";
      }
      this.getList(1, sortBy, orderBy);
    },
    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
          }
        })
        .catch(e => {});
    },
    getShiftDetails(id) {
      this.$api
        .getAPI({ _action: "/shift/?pk=" + id })
        .then(res => {
          this.shift = res;
        })
        .catch(e => {});
    },
    getExport() {
      if (this.store_id) {
        this.filterObj.store_id = store_id;
      }

      if (this.search) {
        this.filterObj.search = search;
      }

      this.filterObj.to_date = moment(String(this.date.startDate)).format(
        "Y-M-D"
      );

      this.filterObj.from_date = moment(String(this.date.endDate)).format(
        "Y-M-D"
      );

      var queryParam = "";
      for (let key in this.filterObj) {
        if (queryParam == "") {
          queryParam += "?" + key + "=" + this.filterObj[key];
        } else {
          queryParam += "&" + key + "=" + this.filterObj[key];
        }
      }
      this.$api.getAndDownloadAPI({ _action: "/report/export_shift/" +
          localStorage.getItem("client_id") +
          queryParam
        , _fileName: 'shift.csv'})
    },
  },

  mounted() {
    if (localStorage.getItem("currency")) {
      this.currency = localStorage.getItem("currency");
    }

    this.decimal_separator = localStorage.getItem("decimal_separator") || ".";
    this.precision = (localStorage.getItem("decimal_separator") || "") == "" ? 0 : 2;
    this.getStoreList();
    this.getList(1);
  }
};
</script>
<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-md-12 d-lg-flex justify-content-end">
            <div class="date-range-picker-wrap d-flex mb-lg-0 mb-3 w-xs-100" style="width: 304px">
              <CustomerDateRangePicker
              class="w-xs-100"
              :date.sync="date"
              @update="getList(1)"></CustomerDateRangePicker>
            </div>

            <div
              class="text-right custom-select-dd d-inline-block mr-3 mr-md-1 mr-lg-3 ml-lg-2 mb-lg-0 mb-3 w-xs-100"
              style="width: 180px;"
            >
              <select v-model="filterObj.store_id" @change="getList(1)" class="form-control">
                <option value>{{$lang.messages.all_stores}}</option>
                <option v-for="store in storeList" :key="store.id" :value="store.id">{{store.name}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="card rounded-5">
              <div class="pink-tape py-1 mt-3">
                <div class="row">
                  <div class="col-lg-9 col-5 align-self-center">
                    <a
                      href="javascript:void(0)"
                      class="font-20 mb-0 text-regular text-hover-primary text-nowrap"
                      @click="getExport()"
                    >
                      {{$lang.messages.export}}
                      <i class="mdi mdi-download align-text-top"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="card-body table-responsive">
                <table class="table table-striped table-style-1">
                  <thead>
                    <tr>
                      <th scope="col">Sr.no</th>
                      <th scope="col">{{$lang.messages.pos}}</th>
                      <th scope="col">{{$lang.messages.opening_time}}</th>
                      <th scope="col">{{$lang.messages.closing_time}}</th>
                      <th scope="col">{{$lang.messages.expected_cash_amount}}</th>
                      <th scope="col">{{$lang.messages.actual_cash_amount}}</th>
                      <th scope="col">{{$lang.messages.difference}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      data-toggle="modal"
                      data-target="#ShiftsDetail"
                      class="clickable-row"
                      v-for="(item,i) in list"
                      :key="item.id"
                      @click="getShiftDetails(item.id)"
                    >
                      <td>{{(currentPage -1) * itemsPerPage + i +1}}</td>
                      <td>{{item.pos_name}}</td>
                      <td>{{item.open_shift | moment("MMM DD, YYYY HH:mm")}}</td>
                      <td>{{item.closed_shift | moment("MMM DD, YYYY HH:mm")}}</td>
                      <td>
                        <vue-numeric
                          v-if="item.expected_cash_amount"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item.expected_cash_amount"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                      <td>
                        <vue-numeric
                          v-if="item.actual_cash_amount"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item.actual_cash_amount"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                      <td>
                        <vue-numeric
                          v-if="item.difference"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="item.difference"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <ErrorComponent @retry="retry()" ref="errorComonent" />
              </div>
            </div>

            <div class="page-bottom-pagination text-right">
              <Pagination
                @page-change="pageChange"
                @items-per-page-change="itemsPerPageChange()"
                ref="listPagination"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Right side modal -->
    <div
      class="modal right fade"
      id="ShiftsDetail"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel2"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header d-block text-center">
            <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> -->
            <h4
              class="modal-title f-semi-bold font-20"
              id="myModalLabel2"
            >{{$lang.messages.shift_report}}</h4>
          </div>
          <div class="modal-body" style="padding-bottom: 0; border-bottom:1px solid #ddd">
            <div class="card">
              <div class="card-body px-0 pt-0">
                <h4>
                  <span class="f-semi-bold">{{$lang.messages.store}}:</span>
                  {{shift.store_name}}
                </h4>
                <p class="font-14">
                  <span class="f-semi-bold">{{$lang.messages.pos}}:</span>
                  {{shift.pos_name}}
                </p>
                <table class="table table-style-1 table-borderless mt-0 bg-light">
                  <tbody>
                    <tr>
                      <td class="p-1">{{$lang.messages.shift_opened}}: {{shift.shift_open_by_name}}</td>
                      <td
                        class="p-1 text-right"
                      >{{shift.open_shift | moment("MMM DD, YYYY HH:mm")}}</td>
                    </tr>
                    <tr>
                      <td class="p-1">{{$lang.messages.shift_closed}}: {{shift.shift_close_by_name}}</td>
                      <td
                        class="p-1 text-right"
                      >{{shift.closed_shift | moment("MMM DD, YYYY HH:mm")}}</td>
                    </tr>
                  </tbody>
                </table>

                <h4 class="text-primary f-semi-bold">{{$lang.messages.cash_drawer}}</h4>
                <table class="table table-style-1 table-borderless mt-0 bg-light">
                  <tbody>
                    <tr>
                      <td class="p-1">{{$lang.messages.starting_cash}}</td>
                      <td class="p-1 text-right">
                        <vue-numeric
                          v-if="shift.starting_cash"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="shift.starting_cash"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                    </tr>
                    <tr>
                      <td class="p-1">{{$lang.messages.cash_payments}}</td>
                      <td class="p-1 text-right">
                        <vue-numeric
                          v-if="shift.cash_payment"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="shift.cash_payment"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                    </tr>
                    <tr>
                      <td class="p-1">{{$lang.messages.cash_refunds}}</td>
                      <td class="p-1 text-right">
                        <vue-numeric
                          v-if="shift.cash_refunds"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="shift.cash_refunds"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                    </tr>
                    <tr>
                      <td class="p-1">{{$lang.messages.paid_in}}</td>
                      <td class="p-1 text-right">
                        <vue-numeric
                          v-if="shift.paid_in"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="shift.paid_in"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                    </tr>
                    <tr>
                      <td class="p-1">{{$lang.messages.paid_out}}</td>
                      <td class="p-1 text-right">
                        <vue-numeric
                          v-if="shift.paid_out"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="shift.paid_out"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                    </tr>
                    <tr>
                      <td class="p-1">{{$lang.messages.expected_cash_amount}}</td>
                      <td class="p-1 text-right">
                        <vue-numeric
                          v-if="shift.expected_cash_amount"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="shift.expected_cash_amount"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                    </tr>
                    <tr>
                      <td class="p-1">{{$lang.messages.actual_cash_amount}}</td>
                      <td class="p-1 text-right">
                        <vue-numeric
                          v-if="shift.actual_cash_amount"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="shift.actual_cash_amount"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                    </tr>
                    <tr>
                      <td class="p-1 f-bold">{{$lang.messages.difference}}</td>
                      <td class="p-1 f-bold text-right">
                        <vue-numeric
                          v-if="shift.difference"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="shift.difference"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <h4 class="text-primary f-semi-bold">{{$lang.messages.sales_summary}}</h4>
                <table class="table table-style-1 table-borderless mt-0 bg-light">
                  <tbody>
                    <tr>
                      <td class="p-1 f-bold">{{$lang.messages.gross_sales}}</td>
                      <td class="p-1 text-right">
                        <vue-numeric
                          v-if="shift.gross_sale"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="shift.gross_sale"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                    </tr>
                    <tr>
                      <td class="p-1">{{$lang.messages.refunds}}</td>
                      <td class="p-1 text-right">
                        <vue-numeric
                          v-if="shift.refunds"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="shift.refunds"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                    </tr>
                    <tr>
                      <td class="p-1">{{$lang.messages.discounts}}</td>
                      <td class="p-1 text-right">
                        <vue-numeric
                          v-if="shift.discounts"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="shift.discounts"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                    </tr>
                    <tr>
                      <td class="p-1">{{$lang.messages.additional_cost}}</td>
                      <td class="p-1 text-right">
                        <vue-numeric
                          v-if="shift.additional_costs"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="shift.additional_costs"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                    </tr>
                    <tr>
                      <td class="p-1 f-bold">{{$lang.messages.net_sales}}</td>
                      <td class="p-1 text-right">
                        <vue-numeric
                          v-if="shift.net_sale"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="shift.net_sale"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                    </tr>
                    <tr>
                      <td class="p-1 f-bold">{{$lang.messages.total_tendered}}</td>
                      <td class="p-1 text-right">
                        <vue-numeric
                          v-if="shift.total_tendered"
                          v-bind:precision="precision"
                          :separator="decimal_separator"
                          :currency="currency"
                          :value="shift.total_tendered"
                          :read-only="true"
                        ></vue-numeric>
                        <template v-else>0</template>
                      </td>
                    </tr>
                    <tr v-for="(item, key) in shift.payments" :key="key">
                        <td class="p-1">{{key}}</td>
                        <td class="p-1 text-right">
                          <vue-numeric
                            v-bind:precision="precision"
                            :separator="decimal_separator"
                            :currency="currency"
                            :value="item"
                            :read-only="true"
                          ></vue-numeric>
                        </td>
                    </tr>
                  </tbody>
                </table>
                <!-- <h4 class="text-primary f-semi-bold">Pay in / Pay out</h4>
                <table class="table table-style-1 table-responsive table-borderless mt-0 bg-light">
                  <tbody>
                    <tr>
                      <td class="p-1 f-bold">Gross sales</td>
                      <td class="p-1 text-right">200.00</td>
                    </tr>
                  </tbody>
                </table>-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- modal-content -->
    </div>
  </div>
</template>
